import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import "../../components/common/HowItWorksModal/howItWorksModal.css";

const HideFromReportsModal = ({ show, onHide, onConfirm, isLoading }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="how-it-works-modal-wrapper"
    >
      <Modal.Body className="pt-0">
        <Modal.Header className="modal-title-with-border" closeButton>
          <Modal.Title>Hide from Reports?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 pb-2">
          <p className="mb-2">
            Your future reports will not include this disclaimer section. You
            can add it back at any time.
          </p>
          <p className="mb-0">Do you want to hide this section?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={onHide}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Hide"
            )}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default HideFromReportsModal;
